import { useState } from 'react'
import { useUserStore } from '@/hooks/useUserStore'
import { useAbortableRequest } from '@/hooks/useAbortableRequest'
import headImg from '@/assets/images/logo-server.png'

interface UseUserInfoReturn {
  loading: boolean
  fetchUserInfo: () => Promise<void>
  clearUser: () => void
  getUserInfo: () => void
  setUserInfo: (data: string) => void
}

export const useUserInfo = (): UseUserInfoReturn => {
  const { sendRequest } = useAbortableRequest()
  const { dispatch } = useUserStore()
  const [loading, setLoading] = useState(false)
  // 获取用户信息
  const fetchUserInfo = async (): Promise<void> => {
    const token = localStorage.getItem('uniToken')
    setLoading(true)
    if (!token) {
      console.log('未登录')
      setLoading(false)
      return
    }
    const userInfo = JSON.parse(getUserInfo())
    if (token && userInfo?.nickname && userInfo?.headimgurl) {
      dispatch({ type: 'SET_USER_INFO', payload: userInfo })
      setLoading(false)
      return
    }
    try {
      const result: any = await sendRequest({
        method: 'post',
        url: 'userinfo',
        data: {}
      })
      if (result?.res) {
        result.res.data.headimgurl = result.res.data.headimgurl || headImg
        result.res.data.nickname = result.res.data.nickname || '果宝' + (result.res.data.created_at + '').slice(-4)
        dispatch({ type: 'SET_USER_INFO', payload: result.res.data })
        setUserInfo(JSON.stringify(result.res.data))
      }
    } finally {
      setLoading(false)
    }
  }
  const clearUser = () => {
    localStorage.removeItem('userInfo')
  }
  const getUserInfo = () => {
    return localStorage.getItem('userInfo') || '{}'
  }
  const setUserInfo = (data: string) => {
    return localStorage.setItem('userInfo', data)
  }
  return {
    loading,
    fetchUserInfo,
    clearUser,
    getUserInfo,
    setUserInfo
  }
}
